var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    fill: "url(#paint0_linear_1365_1391)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8339 22.8709C11.476 23.2289 11.476 23.8093 11.8341 24.1672C12.1921 24.5252 12.7725 24.5252 13.1304 24.1671L18.2502 19.0464L23.3704 24.1667C23.7284 24.5246 24.3088 24.5246 24.6668 24.1667C25.0248 23.8087 25.0248 23.2283 24.6668 22.8703L19.5465 17.75L24.6664 12.6292C25.0243 12.2711 25.0243 11.6907 24.6662 11.3328C24.3083 10.9748 23.7279 10.9749 23.3699 11.3329L18.25 16.4537L13.1298 11.3333C12.7718 10.9754 12.1914 10.9754 11.8334 11.3333C11.4754 11.6913 11.4754 12.2717 11.8334 12.6297L16.9539 17.7501L11.8339 22.8709Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1365_1391",
    x1: 34.5208,
    y1: 5.67038,
    x2: 4.9375,
    y2: 34.5141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568594,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconModal);
export default __webpack_public_path__ + "static/media/close_icon_modal.69bb94b8f3ed89e14461ef46ba6932e4.svg";
export { ForwardRef as ReactComponent };